/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

/**
 * An error thrown when an invalid profile could not be processed.
 */
export default class InvalidProfileError extends Error {}
